// extracted by mini-css-extract-plugin
export default {"mainContainer":"RescriptHistoryTable_mainContainer__ZE1zu"};